import {
  Box,
  TableRow,
  TableCell,
  IconButton,
  Typography,
  Avatar,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import defaultStoreImage from "../../../../assets/svg/defaultStore.svg";
import { cleanLocalStorage } from "../../../../utils/cleanLocalStorage";
import ComercialDrawer from "../../../../components/pet-beauty/CormercialDrawer";
import ComercialInterfaceHeader from "../../../../components/comercial/ComercialInterfaceHeader";
import { IEmployee } from "../../../../services/api/Employee/types";
import { IStore } from "../../../../services/api/Store/types";
import { setLocalStorageItem } from "../../../../hooks/localStorageHooks";
import useFetchUserEmployees from "../../../../hooks/entities/useFetchUserEmployedStores";
import { sharedStyles } from "../../../../styles/shared";
import ComercialTable from "../../../../components/comercial/ComercialTable";
import { LeftMarginBackButton } from "@/components/general/buttons/BackPageButton";
import { useTranslation } from "react-i18next";

const MyWorkscales = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  cleanLocalStorage();

  const { userEmployees, loading } = useFetchUserEmployees();

  const handleSelectEmployee = (employee: IEmployee) =>
    setLocalStorageItem("selectedEmployee", employee);

  const handleEditEmployeeClick = (employee: IEmployee, store: IStore) => {
    handleSelectEmployee(employee);
    setLocalStorageItem("selectedStore", store);
    navigate("/employees/edit");
  };

  const storesTableHeader = (
    <TableRow>
      <TableCell align="left">{t("myWorkscales.table.store")}</TableCell>
      <TableCell align="right">{t("myWorkscales.table.actions")}</TableCell>
    </TableRow>
  );

  const storesTableBody = (
    <>
      {userEmployees?.length > 0 ? (
        userEmployees?.map((employee, index) => (
          <TableRow
            key={employee.id}
            sx={{
              "&:last-child td, &:last-child th": { border: 0 },
            }}
          >
            <TableCell
              component="th"
              sx={{ ...sharedStyles.horizontalContent }}
              align="left"
            >
              <Avatar
               src={employee.store?.images?.[0]?.thumbnailUrl ?? defaultStoreImage}
                sx={sharedStyles.tableAvatarStyle}
              />

              <ListItemText
                primary={employee.store?.name}
                secondary={employee.store?.CNPJ}
                primaryTypographyProps={{ fontWeight: 500 }}
              />
            </TableCell>

            <TableCell align="right">
              <Tooltip title={t("myWorkscales.tooltips.edit")}>
                <IconButton
                  color="primary"
                  onClick={() =>
                    handleEditEmployeeClick(
                      userEmployees[index],
                      employee.store
                    )
                  }
                >
                  <EditCalendarIcon />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell>
            <Typography color="text.secondary" variant="body2">
                {t("myWorkscales.empty")}
            </Typography>
          </TableCell>
        </TableRow>
      )}
    </>
  );

  const renderStoresPageContent = (
    <>
      <LeftMarginBackButton />
      <ComercialInterfaceHeader title={t("myWorkscales.title")} />
      <Box width="100%">
        {!loading ? (
          <ComercialTable header={storesTableHeader} body={storesTableBody} />
        ) : (
          <Box sx={styles.loadingContainer}>
            <CircularProgress />
          </Box>
        )}
      </Box>
    </>
  );

  return (
    <Box sx={sharedStyles.sharedMainContainer}>
      <ComercialDrawer content={renderStoresPageContent} />
    </Box>
  );
};

export default MyWorkscales;

const styles = {
  loadingContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "50px 0px",
  },
};
